import { IResultatomrade } from "./verksamhetsomraden-models";

export interface IMarknadsprislista {
    id?: number;
    violId: string;
    benamning: string;
    vidLeveransGallande: boolean;
    gallerFrom: Date;
    gallerTom: Date;
    aktuell: boolean;
    typ: string;
    resultatomraden: IResultatomrade[];
    handelssortimentsgrupper: IHandelssortimentsgrupp[];
}

export interface IHandelssortimentsgrupp {
    id: number;
    namn: string;
    kortnamn: string;
}

export interface ICommandResult {
    id: number;
    rowVersion: string;
}

export interface IMarknadsprislistaSearchParamsModel{
    benamning?: string;
    violId?: string;
    gallerFrom?: Date;
    gallerTom?: Date;
    typ: string;
    resultatomraden: IResultatomrade[];
    handelssortimentsgrupper: IHandelssortimentsgrupp[];
    isAktuell?: boolean;
}

export class SaveMarknadsprislistaCommand {
    id: number;
    violId: string;
    benamning: string;
    vidLeveransGallande: boolean;
    gallerFrom: Date;
    gallerTom: Date;
    aktuell: boolean;
    typ: string;
    resultatomraden: number[];
    handelssortimentsgrupper: number[];

    constructor(source: IMarknadsprislista) {
        this.id = source.id;
        this.violId = source.violId;
        this.benamning = source.benamning;
        this.vidLeveransGallande = source.vidLeveransGallande;
        this.gallerFrom = source.gallerFrom;
        this.gallerTom = source.gallerTom;
        this.aktuell = source.aktuell;
        this.typ = source.typ;
        this.resultatomraden = source.resultatomraden.map(x => x.id);
        this.handelssortimentsgrupper = source.handelssortimentsgrupper.map(x => x.id);
    }
}
